import TrackerProvider from '@fingo/lib/components/tracker/TrackerProvider';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from '@fingo/lib/components/layout/Layout';
import { OAuthCallbackHandler } from '@fingo/lib/components/auth';
import AppRoutes from './AppRoutes';
import WorkspaceNavbar from './components/layout/navbar/WorkspaceNavbar';

const App = () => (
  <Router>
    {/* Estos providers no se pueden dejar atrás porque usan ruteo */}
    <TrackerProvider
      frontendName="itau"
      googleAnalyticsTag={process.env.REACT_APP_GOOGLE_ANALYTICS_TAG}
    >
      {/* TODO: Agregar Navbar Custom si es necesario */}
      <OAuthCallbackHandler>
        <Layout NavbarComponent={WorkspaceNavbar} defaultBackgroundColor="common.white">
          <AppRoutes />
        </Layout>
      </OAuthCallbackHandler>
    </TrackerProvider>
  </Router>
);

export default App;
